function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 2.69h-3.923A2.802 2.802 0 008.437.817 2.802 2.802 0 005.799 2.69H1.875C.839 2.69 0 3.53 0 4.566V17.69c0 1.036.84 1.875 1.875 1.875H15a1.874 1.874 0 001.875-1.875V4.566c0-1.036-.84-1.875-1.875-1.875zm-6.563 0a.937.937 0 11.001 1.875.937.937 0 010-1.874zM3.75 15.817h6.563V13.94H3.75v1.875zm9.375-3.75H3.75V10.19h9.375v1.875zM3.75 8.316h9.375V6.44H3.75v1.875z",
  fill: "#000"
});

var SvgAssignments = function SvgAssignments(props) {
  return React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='17' height='20' viewBox='0 0 17 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M15 2.69092H11.0766C10.6922 1.60342 9.66094 0.815918 8.4375 0.815918C7.21406 0.815918 6.18281 1.60342 5.79844 2.69092H1.875C0.839062 2.69092 0 3.52998 0 4.56592V17.6909C0 18.7269 0.839063 19.5659 1.875 19.5659H15C16.0359 19.5659 16.875 18.7269 16.875 17.6909V4.56592C16.875 3.52998 16.0359 2.69092 15 2.69092ZM8.4375 2.69092C8.95312 2.69092 9.375 3.10811 9.375 3.62842C9.375 4.14873 8.95312 4.56592 8.4375 4.56592C7.92188 4.56592 7.5 4.14873 7.5 3.62842C7.5 3.10811 7.92188 2.69092 8.4375 2.69092ZM3.75 15.8159H10.3125V13.9409H3.75V15.8159ZM13.125 12.0659H3.75V10.1909H13.125V12.0659ZM3.75 8.31592H13.125V6.44092H3.75V8.31592Z' fill='black'/%3E %3C/svg%3E";
export { SvgAssignments as ReactComponent };